import concaveman from 'concaveman';
import { BufferGeometry, Vector2Tuple, Vector3 } from 'three';

export interface Outline2DOptions {
  concavity?: number;
  lengthThreshold?: number;
}

export class Outline2D {
  array: Vector2Tuple[] = [];

  setFromGeometry(geometry: BufferGeometry, options?: Outline2DOptions): this {
    const vertices: Vector2Tuple[] = [];
    const positionAttribute = geometry.getAttribute('position');
    const vertex = new Vector3();
    for (let i = 0; i < positionAttribute.count; i++) {
      vertex.fromBufferAttribute(positionAttribute, i);
      vertices.push([vertex.x, vertex.z]);
    }

    return this.setFromPoints(vertices, options);
  }

  setFromPoints(points: Vector2Tuple[], options?: Outline2DOptions) {
    // concaveman crashes on degenerate input; fewer than 3 points cannot
    // form an outline, the points are their own hull
    if (points.length < 3) {
      this.array = points.map((p) => [p[0], p[1]]);
      return this;
    }
    this.array = concaveman(
      points,
      options?.concavity ?? Infinity,
      options?.lengthThreshold ?? 1
    ) as Vector2Tuple[];
    return this;
  }
}
